// ----- Phase phase-form-templates-ui-fixes (FT-SR-4) -----
//
// Canonical set of document template types. Before this phase the
// "Template type" field on the Submission Requirements add-row form was
// free text, so admins typed inconsistent values ("CoverLetter" vs
// "Cover Letter"). These are now the dropdown options. The list matches
// the values the backend seeds (src/routes + KB-seed migration) plus the
// "Other" escape hatch.

export const TEMPLATE_TYPES = [
  'CoverLetter',
  'ApplicationForm',
  'ProductInformation',
  'ClinicalOverview',
  'InvestigatorBrochure',
  'ClinicalProtocol',
  'AnnualReport',
  'MeetingRequest',
  'VariationForm',
  'PSUR',
  'ProductMonograph',
  'SafetyReport',
  'LabellingDocument',
  'Other',
] as const;

export type TemplateType = (typeof TEMPLATE_TYPES)[number];
